import { toast } from "sonner";

export async function updateAdditionalPayments(data,id) {
    const token = sessionStorage.getItem('token'); // Retrieve the JWT token from session storage
    const headers = {
        'Authorization': `Bearer ${token}`, // Pass the token in the Authorization header
        'Content-Type': 'application/json'
    };
    const postUrl = `${process.env.REACT_APP_API_URL}/admin/profesor/pago-adicional/actualizar/${id}`; // Assuming data contains an id field for the payment to update

    try {
        const postResponse = await fetch(postUrl, {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(data) // Convert the time value data to JSON
        });

        const contentType = postResponse.headers.get('content-type');
        const responseText = await postResponse.text(); // Read the response as text

        if (!postResponse.ok) {
            console.error('Server responded with:', responseText);
            throw new Error('Failed to update time value');
        }

        if (contentType && contentType.includes('application/json')) {
            toast.success("Successfully updated additional payment");
            return JSON.parse(responseText); // Attempt to parse the response as JSON
        } else {
            console.log('Response is not JSON:', responseText);
            toast.success("Successfully updated additional payment");
            return { message: responseText }; // Return the response text as a message
        }

    } catch (error) {
        toast.error("Error updating additional payment: " + error.message);
        throw new Error(`Failed to update additional payment: ${error.message}`);
    }
}